import React, { createContext, useState, useContext, ReactNode } from 'react';

type AccordionContext = {
  active: Array<string>;
  setActive: React.Dispatch<React.SetStateAction<Array<string>>>;
};
type ProductAccordionProviderProps = { initialActiveState?: Array<string>; children: ReactNode };

const ProductAccordionContext = createContext<AccordionContext | undefined>(undefined);

const goToAccordion = (id: string, accordion: AccordionContext): void => {
  accordion.setActive([...new Set([...accordion.active, id])]);
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};

function ProductAccordionProvider({ initialActiveState = [], children }: ProductAccordionProviderProps): JSX.Element {
  const [activeState, setActiveState] = useState(initialActiveState);

  return (
    <ProductAccordionContext.Provider
      value={{
        active: activeState,
        setActive: setActiveState,
      }}
    >
      {children}
    </ProductAccordionContext.Provider>
  );
}

function useProductAccordion(): AccordionContext {
  const context = useContext(ProductAccordionContext);
  if (context === undefined) {
    throw new Error('useProductAccordion must be used within a ProductAccordionProvider');
  }
  return context;
}

export { ProductAccordionProvider, useProductAccordion, goToAccordion };
